import * as THREE from "three";
import { fmt3 } from "./viewerUtils";

export type FragDebugInfo = {
  camPos: THREE.Vector3;
  camDir: THREE.Vector3;
  target: THREE.Vector3;
  syncTarget: THREE.Vector3 | null;
};

type DebugOverlayProps = {
  enabled: boolean;
  debugInfo: FragDebugInfo | null;
};

export function DebugOverlay({ enabled, debugInfo }: DebugOverlayProps) {
  if (!enabled || !debugInfo) return null;

  return (
    <div style={{
      position: "absolute", bottom: 8, left: 8, zIndex: 20,
      background: "rgba(0,0,0,0.72)", color: "#0f0", fontFamily: "monospace",
      fontSize: 11, padding: "6px 10px", borderRadius: 4, lineHeight: 1.6,
      pointerEvents: "none", whiteSpace: "pre",
    }}>
      {[
        "-- 3D camera (Three.js world) --",
        `pos     ${fmt3(debugInfo.camPos)}`,
        `dir     ${fmt3(debugInfo.camDir)}`,
        `target  ${fmt3(debugInfo.target)}`,
        debugInfo.syncTarget
          ? `-- sync target (from 2D) --\n2d->3d   ${fmt3(debugInfo.syncTarget)}`
          : "-- sync OFF --",
      ].join("\n")}
    </div>
  );
}
